/* eslint-disable @typescript-eslint/no-unused-vars */
import classNames from 'classnames';
import { useGetUser } from 'src/hooks';
import { PlanFamily, PlanKind, PlanSectionType, UserTier } from 'src/types';
import { useMemo } from 'react';
import { OfferSection } from 'src/v2/pages/subscription/components/CancelSubscription/components/OfferSection';

type ComplementaryOfferPlanItemProps = {
  planToOffer?: PlanKind;
};

export const ComplementaryOfferPlanItem = ({
  planToOffer,
}: ComplementaryOfferPlanItemProps) => {
  const { isTeamsTier, isProTier, tier_id } = useGetUser();

  const isStandardType = tier_id === UserTier.STANDARD;
  const isProType = tier_id === UserTier.PRO;
  const isUltraType = tier_id === UserTier.ULTRA;

  //TODO: confirm with the Product team
  const type: PlanSectionType = useMemo(() => {
    if (isStandardType) {
      return 'Standard';
    }
    if (isProType) {
      return 'Pro';
    }
    if (isUltraType) {
      return 'Ultra';
    }
    if (tier_id === UserTier.TEAMS_ULTRA) {
      return 'Teams_Ultra';
    }
    return 'SuperNinja_Ultra';
  }, [isProType, isStandardType, isUltraType, tier_id]);

  const planFamily = useMemo((): PlanFamily => {
    if (
      tier_id === UserTier.TEAMS_STANDARD ||
      tier_id === UserTier.TEAMS_PRO ||
      tier_id === UserTier.TEAMS_ULTRA ||
      tier_id === UserTier.TEAMS_SUPERNINJA_ULTRA ||
      tier_id === UserTier.BUSINESS_SUPERNINJA_PRO ||
      tier_id === UserTier.BUSINESS_SUPERNINJA_ULTRA ||
      tier_id === UserTier.BUSINESS_SUPERNINJA_MAX ||
      tier_id === UserTier.CREDIT_BUSINESS_PRO
    ) {
      return PlanFamily.BUSINESS;
    }

    if (
      tier_id === UserTier.SUPERNINJA_PRO ||
      tier_id === UserTier.SUPERNINJA_ULTRA ||
      tier_id === UserTier.SUPERNINJA_MAX ||
      tier_id === UserTier.SUPERNINJA_STANDARD ||
      tier_id === UserTier.CREDIT_PRO
    ) {
      return PlanFamily.MAX;
    }

    if (
      tier_id === UserTier.ULTRA ||
      tier_id === UserTier.STANDARD ||
      isProTier
    ) {
      return PlanFamily.PRO;
    }

    return PlanFamily.UNDEFINED;
  }, [tier_id, isProTier]);

  return (
    <div
      className={classNames('nj-plan-section nj-plan-section--cancel-flow', {
        'nj-plan-section--teams': isTeamsTier,
      })}
    >
      <OfferSection
        key={type}
        planFamily={planFamily}
        planKindToOffer={planToOffer}
        planTier={tier_id as UserTier}
      />
    </div>
  );
};
